<template>
  <router-view/>
</template>

<script setup>
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
body { display: block; margin: 0; background: #f0f2f5; }
#app {
  font-family: "Microsoft YaHei", "PingFang SC", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  min-height: 100vh;
}
</style>
